/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Link,
} from '@mui/material';
import Button from '../components/button';

interface ErroredConnectionProps {
  isError: boolean,
  acknowledge: () => void,
}

const openIntercomWindow = () => {
  // @ts-ignore
  window.Intercom('show');
};

const ArcGISErroredConnection = (
  { isError, acknowledge }: ErroredConnectionProps,
) => (
  <Dialog
    open={isError}
    onClose={acknowledge}
    aria-labelledby="alert-error-title"
    aria-describedby="alert-error-description"
  >
    <DialogTitle id="alert-error-title">
      Connection Failed
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-error-description">
        Please check the URL for errors, ensure the server is online, and verify your internet connection.
        If the problem persist
        {' '}
        <Link component="button" onClick={openIntercomWindow}>Contact Support</Link>
        .
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={acknowledge}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default ArcGISErroredConnection;
